import React, { Children, useContext, useEffect } from 'react';
import { Route as ReactRoute, Routes } from 'react-router-dom';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { RouteContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { bool, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { deprecationWarningMessage } from '@philips-internal/oswald-ui-utils';
import { useForceUpdate } from '../../hooks/use-force-update.js';
import { RouteAPI } from './route-api.js';
import { RouteChildren } from './route-children.js';
const RouteContainer = {
    acceptedTypes: [
        ComponentType.LAYOUT,
    ],
    name: '',
};
function detectQueryString(route = '') {
    return route.includes('?');
}
function detectWildcard(route = '') {
    return route.includes('*');
}
function Route(props) {
    const context = useContext(RouteContext.Context);
    const forceUpdate = useForceUpdate();
    useEffect(() => {
        const unlistenHistoryChange = HistoryService.listenHistoryChange(() => forceUpdate());
        const hasQueryString = detectQueryString(props.route);
        const hasWildcard = detectWildcard(props.route);
        if (hasQueryString) {
            deprecationWarningMessage({
                deadlineVersion: '7.0.0',
                feature: true,
                replaced: 'route with query parameters',
                scope: 'Route',
                startingVersion: '4.0.0-beta.129',
            });
        }
        if (hasWildcard) {
            throw Error(`[Route]: Route components can't have wildcards.`);
        }
        return () => {
            unlistenHistoryChange();
        };
    });
    if (props.uuid && Children.count(props.children) === 0) {
        return (React.createElement(Container, { acceptedTypes: RouteContainer.acceptedTypes, className: "u-expand", uuid: props.uuid }));
    }
    const nestedContext = context.nestedContext(props.route);
    const wildcardRoute = props.route?.endsWith('/')
        ? props.route?.concat('*')
        : props.route?.concat('/*');
    const routeToUse = props.exact
        ? props.route
        : wildcardRoute;
    const element = (React.createElement(RouteChildren, { context: nestedContext, route: routeToUse }, props.children));
    return (React.createElement(Routes, null,
        React.createElement(ReactRoute, { element: element, path: routeToUse }),
        "s"));
}
Route.propTypes = {
    exact: bool,
    route: string,
    uuid: string,
};
const awesomeProps = {
    api: RouteAPI,
    containers: [RouteContainer],
    name: 'Route',
    type: ComponentType.BEHAVIOR,
};
AwesomeComponent(awesomeProps)(Route);
export { Route, };
//# sourceMappingURL=route.js.map